import MaintenanceWorkflowForwardingCheckinEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/CheckinEntry'
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/EstablishmentChoiceEntry'
import MaintenanceWorkflowForwardingActions from '../../../Sections/ForwardingActions'

const ExecutionEntryOnGoingEstablishmentChoice = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingActions />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection manualEntryProps={{ showProposalDiagnostic: true }} />
    </>
  )
}

export default ExecutionEntryOnGoingEstablishmentChoice
